import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { useLanguage } from '../i18n/LanguageContext';
import { DOCS, CONTACT } from '../legal/docs';
import { pick, type Lang } from '../offers/config';
const UI = {
  es: {
    notFound: 'Esta página no existe',
    backHome: 'Volver al inicio',
    updated: 'Última actualización',
    contact: 'Contacto',
    contactText: 'Para cualquier consulta sobre este documento, escríbenos a',
    legal: 'Legal'
  },
  en: {
    notFound: 'This page does not exist',
    backHome: 'Back to home',
    updated: 'Last updated',
    contact: 'Contact',
    contactText: 'For any question about this document, write to us at',
    legal: 'Legal'
  }
};
export function Legal() {
  const {
    slug
  } = useParams();
  const {
    language
  } = useLanguage();
  const lang = (language === 'en' ? 'en' : 'es') as Lang;
  const t = UI[lang];
  const doc = slug ? DOCS[slug] : undefined;
  if (!doc) {
    return <div className="min-h-screen bg-background text-white flex flex-col" data-id="element-412" data-mp="27jjx7l36ndki">
        <Navbar data-id="element-413" data-mp="23ihvmxlsmpfd" />
        <div className="flex-1 flex flex-col items-center justify-center gap-6 px-6 text-center" data-id="element-414" data-mp="23izywe6vi3ws">
          <h1 className="font-display text-3xl" data-id="element-415" data-mp="2hisna2uxg81l">{t.notFound}</h1>
          <Link to="/" className="text-accent hover:underline" data-id="element-416" data-mp="2cjpp92dd7234">
            {t.backHome}
          </Link>
        </div>
        <Footer data-id="element-417" data-mp="1ovom68yygdv3" />
      </div>;
  }
  const blocks = pick(doc.blocks, lang);
  return <div className="min-h-screen bg-background text-white" data-id="element-418" data-mp="1jwbtv8pbeel4">
      <Navbar data-id="element-419" data-mp="1ykgbsagjmm2u" />

      <article className="max-w-[720px] mx-auto px-5 sm:px-6 pt-32 md:pt-40 pb-24" data-id="element-420" data-mp="1yk6o4tiz0r0b">
        <div className="flex items-center gap-2 text-[13px] text-white/40 mb-8" data-id="element-421" data-mp="1ttq9j63eyzcd">
          <Link to="/" className="hover:text-white/70 transition-colors" data-id="element-422" data-mp="1trnajwka9vvi">
            Blinkblis
          </Link>
          <span data-id="element-423" data-mp="1152hmro5tbpu">/</span>
          <span className="text-accent" data-id="element-424" data-mp="115kn8ewpp2af">{t.legal}</span>
        </div>

        <h1 className="font-display text-[34px] sm:text-5xl font-semibold tracking-[-0.03em] leading-[1.1] mb-4" data-id="element-425" data-mp="11383pxbb2jv9">
          {pick(doc.title, lang)}
        </h1>
        <p className="text-[14px] text-white/40 mb-12 pb-8 border-b border-white/10" data-id="element-426" data-mp="364u3adghy7kh">
          {t.updated}: {pick(doc.updated, lang)}
        </p>

        <div className="space-y-6" data-id="element-427" data-mp="3eyp63eu5blwy">
          {blocks.map((block, i) => {
          if ('h' in block) {
            return <h2 key={i} className="font-display text-[22px] sm:text-2xl font-semibold tracking-[-0.02em] text-white pt-6" data-id="element-428" data-mp="2i9hlqa59jium">
                  {block.h}
                </h2>;
          }
          if ('ul' in block) {
            return <ul key={i} className="space-y-3" data-id="element-429" data-mp="2w9sfbkxyjbjh">
                  {block.ul.map(item => <li key={item} className="flex gap-3 text-[16px] leading-[1.75] text-white/60 font-light" data-id="element-430" data-mp="6idnvnudv40l">
                      <span className="text-accent shrink-0 mt-0.5" data-id="element-431" data-mp="lm6rd46k5w81">—</span>
                      <span data-id="element-432" data-mp="gn3w2bgdr4d9">{item}</span>
                    </li>)}
                </ul>;
          }
          return <p key={i} className="text-[16px] leading-[1.8] text-white/60 font-light" data-id="element-433" data-mp="buapdi1cplyj" data-mpi={i}>
                {block.p}
              </p>;
        })}
        </div>

        <div className="mt-14 pt-8 border-t border-white/10" data-id="element-434" data-mp="2t2r2zyu4l4g">
          <h2 className="font-display text-xl font-semibold mb-3" data-id="element-435" data-mp="3u0yuh7wei947">
            {t.contact}
          </h2>
          <p className="text-[16px] text-white/60 font-light leading-relaxed" data-id="element-436" data-mp="3p35nwdr6rd3e">
            {t.contactText}{' '}
            <a href={`mailto:${CONTACT}`} className="text-accent hover:underline" data-id="element-437" data-mp="3l2v520iaos74">
              {CONTACT}
            </a>
            .
          </p>

          <div className="mt-8 flex flex-wrap gap-x-6 gap-y-2 text-[14px]" data-id="element-438" data-mp="1ja73dvlauctg">
            {Object.entries(DOCS).filter(([key]) => key !== slug).map(([key, d]) => <Link key={key} to={`/${key}`} className="text-white/40 hover:text-white transition-colors" data-id="element-439" data-mp="1vbghkzuw9s79">
                  {pick(d.title, lang)}
                </Link>)}
          </div>
        </div>
      </article>

      <Footer data-id="element-440" data-mp="17kt29ting0ao" />
    </div>;
}